import { Dependency, DefaultDependencySettings } from "index";

import ConsentMode from "./../../extentions/consentMode";
import DependencyBase from "./../DependecyBase";
import React from "react";
import Cookies from "js-cookie";

declare global {
    interface Window {
        OneTrust?: any;
        OptanonWrapper?: () => void;
        OnetrustActiveGroups?: any;
    }
}

export interface OneTrustDependencySetting extends DefaultDependencySettings {
    domainKey: string;
    consentModeEnabled: boolean;
    helmetComponent: React.ComponentType;
}

class OneTrust extends DependencyBase<OneTrustDependencySetting> {
    // This feels like a bit of a hack...
    static _componentDependencies: Dependency[] = [];
    public static dependency = () => this._componentDependencies.every((dependency) => dependency());

    constructor(prop: OneTrustDependencySetting) {
        super(prop);
        OneTrust._componentDependencies.push(this.dependency);
    }

    public dependency = () => {
        if (!window?.OneTrust) {
            return false;
        }

        if (!Cookies.get("OptanonAlertBoxClosed")) {
            return false;
        }

        if (window?.dataLayer) {
            return window.dataLayer.some((entry) => entry.event === "OneTrustLoaded");
        }

        return true;
    };

    // Strictly Necessary Cookies: "C0001"
    // Performance Cookies: "C0002"
    // Functional Cookies: "C0003"
    // Targeting Cookies: "C0004"
    // Social Media Cookies: "C0005"

    private static checkScriptConsent = (groups: string[]) => ({
        ad_storage: groups.includes("C0004") ? "granted" : "denied",
        analytics_storage: groups.includes("C0002") ? "granted" : "denied",
        ad_user_data: groups.includes("C0004") ? "granted" : "denied",
        ad_personalization: groups.includes("C0004") ? "granted" : "denied",
        functionality_storage: groups.includes("C0003") ? "granted" : "denied",
    });

    public static onScriptLoaded = () => {
        // https://developer.onetrust.com/docs/sdk/ZG9jOjIyODk1MTE2-google-consent-mode
        window.OptanonWrapper = () => {
            const consentStatus = this.checkScriptConsent(window?.OnetrustActiveGroups.split(",")) as {
                ad_storage: "denied" | "granted";
                analytics_storage: "denied" | "granted";
                ad_user_data: "denied" | "granted";
                ad_personalization: "denied" | "granted";
                functionality_storage: "denied" | "granted";
            };
            ConsentMode.update(consentStatus);
        };
    };

    render = () => {
        const { domainKey, helmetComponent: Helmet } = this.props as OneTrustDependencySetting;
        if (!domainKey) {
            throw new Error("OneTrust cannot render, no domainKey supplied!");
        }

        return (
            <Helmet>
                <script>
                    {`(function() {
                        const elements = document.getElementsByTagName('script')[0];
                        const script = document.createElement('script');
                        script.onload = function () {return window.grebban.gtm.scriptCallback('OneTrust');}
                        script.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
                        script.id = 'OneTrustScript';
                        script.setAttribute('data-domain-script', '${domainKey}')
                        script.setAttribute('data-document-language', 'true')
                        elements.parentNode.insertBefore(script, elements);
                    })();

                    function OptanonWrapper() {}
                `}
                </script>
            </Helmet>
        );
    };
}

export default OneTrust;
